import React from "react";
import { useHistory } from "react-router";

const SingleBookInfo = (props) => {
  const {_id, bookName, authorName, price } = props.info;

  const history = useHistory();

  const handleRemove = () => {
      fetch(`https://infinite-cliffs-81680.herokuapp.com/removeBook/${_id}`,{
          method: 'DELETE',
      })
      .then(res => res.json())
      .then(data =>{
          alert("Do you want remove this book?");
          history.replace('/')
      })

  };

  return (
    <tr>
      <td>{bookName}</td>
      <td>{authorName}</td>
      <td>{price}</td>
      <button onClick={handleRemove} className="btn btn-danger">
        Remove
      </button>
    </tr>
  );
};

export default SingleBookInfo;
